import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { FaUserFriends, FaFolderOpen, FaCheckCircle, FaHourglassHalf, FaMusic } from "react-icons/fa";
import VoiceReviewModal from "../components/VoiceReviewModal";
import {

  FaChevronCircleLeft,
} from "react-icons/fa";
import { FaCircleChevronRight } from "react-icons/fa6";
import {

  useToast,

} from '@chakra-ui/react';
import { FiUser } from "react-icons/fi";
import { db } from "../lib/firebase";
import { collection, addDoc, serverTimestamp, query, where, getDocs, deleteDoc } from "firebase/firestore";
const VoiceApproval = () => {
  const [loading, setLoading] = useState(true);
  const [pendingVerifications, setPendingVerifications] = useState([]);
  const [stats, setStats] = useState({
    totalFiles: 0,
    pendingReview: 0,
    approved: 0,
    rejected: 0,
    totalUsers: 0,
  });
  const [currentAudio, setCurrentAudio] = useState(null);
  const audioRefs = useRef({});
  const [selectedUser, setSelectedUser] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [reviewNotes, setReviewNotes] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(25);
  const toast = useToast();
  // Fetch statistics
  const fetchStatistics = async () => {
    try {
      const res = await axios.get("/api/v1/app/voice-verification/statistics");
      if (res.data.status === "OK") {
        const data = res.data.data.statistics;
        setStats({
          totalFiles: data.total.withVoiceUpload,
          pendingReview: data.verificationStatus.pending.count,
          approved: data.verificationStatus.approved.count,
          rejected: data.verificationStatus.rejected.count,
          totalUsers: data.total.femaleUsers,
        });
      }
    } catch (error) {

      console.error("Error fetching statistics:", error);
    }
  };

  useEffect(() => {
    fetchUsersByStatus(selectedFilter, page);
    fetchStatistics();
  }, [selectedFilter,page, limit]);


  // Fetch pending verifications
  const fetchPendingVerifications = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/v1/app/voice-verification/pending");

      if (res.data.status === "OK") {
        const users = res.data.data.users || [];
        setPendingVerifications(users);
      }
    } catch (error) {
      console.error("Error fetching voice verifications:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleModalSubmit = async (isApproved) => {
    try {
      if (!selectedUser) return;

      //  Validation for rejection reason or review notes
      if (!isApproved && !rejectionReason.trim()) {
        toast({
          title: "Rejection reason is required before rejecting the voice file.",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });

        return;
      }

      const payload = {
        isVerified: isApproved,
        adminNotes: isApproved ? reviewNotes : rejectionReason || reviewNotes,
      };

      console.log("Submitting verification:", {
        userId: selectedUser.id,
        payload: payload,
      })

      const response = await axios.post(
        `/api/v1/app/voice-verification/verify/${selectedUser.id}`,
        payload
      );

      if (response.data.status === "OK") {
        console.log("Verification successful:", response.data.data.message);

        // If rejected, also store in Firestore voice_rejections collection
        if (!isApproved) {
          try {
            await addDoc(collection(db, "voice_rejections"), {
              userId: selectedUser.id,
              userName: selectedUser.fullName || "",
              phoneNumber: selectedUser.phoneNumber || selectedUser.email || "",
              gender: selectedUser.gender || "",
              rejectionReason: rejectionReason || reviewNotes || "",
              adminNotes: reviewNotes || "",
              voiceUrl: selectedUser.voice || "",
              status: "inactive",
              rejectedAt: serverTimestamp(),
            });
            console.log("Rejection stored in Firestore");
          } catch (fsErr) {
            // Don't block the flow if Firestore write fails
            console.error("Firestore rejection log failed:", fsErr);
          }
        } else {
          // If approved, delete any existing rejection doc for this user
          try {
            const q = query(collection(db, "voice_rejections"), where("userId", "==", selectedUser.id));
            const snap = await getDocs(q);
            await Promise.all(snap.docs.map((d) => deleteDoc(d.ref)));
            if (!snap.empty) console.log("Cleared rejection doc from Firestore for user", selectedUser.id);
          } catch (fsErr) {
            console.error("Firestore rejection cleanup failed:", fsErr);
          }
        }

        // Refresh both verifications and statistics
        // await Promise.all([fetchPendingVerifications(), fetchStatistics()]);

        await Promise.all([
  fetchUsersByStatus(selectedFilter, page),
  fetchStatistics(),
]);


        setSelectedUser(null);
        setActionType(null);
        setReviewNotes("");
        setRejectionReason("");
      }
    } catch (error) {
      console.error("Error submitting verification:", error);
      const errorMessage =
        error.response?.data?.error || "Error submitting verification";
      toast({
        title: errorMessage,
        status: "warning",
        duration: 3000,
        isClosable: true,
      });

    }
  };


  const handleDeleteVoice = async (userId) => {
  try {
    const confirmDelete = window.confirm("Are you sure you want to delete this voice?");
    if (!confirmDelete) return;

    await axios.delete(
      `/api/v1/app/voice-verification/deleteVoice/${userId}`
    );

    toast({
      title: "Voice deleted successfully",
      status: "success",
      duration: 3000,
      isClosable: true,
    });

    // refresh list
    await fetchUsersByStatus(selectedFilter, page);
    await fetchStatistics();

  } catch (error) {
    console.error("Delete error:", error);

    toast({
      title: error.response?.data?.message || "Error deleting voice",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  }
};



  const fetchUsersByStatus = async (status = "all", pageNumber = 1) => {
    try {
      setLoading(true);

      const res = await axios.get(
        `/api/v1/app/voice-verification/users?status=${status}&page=${pageNumber}&limit=${limit}`
      );

      if (res.data.status === "OK") {
        const users = res.data.data.users || [];
        const pagination = res.data.data.pagination;

        setPendingVerifications(users);
        setTotalPages(pagination.totalPages);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };




  const handlePlay = (id) => {
    // Pause currently playing audio if different from the one being clicked
    if (currentAudio && currentAudio !== id && audioRefs.current[currentAudio]) {
      audioRefs.current[currentAudio].pause();
      audioRefs.current[currentAudio].currentTime = 0;
    }

    const selectedAudio = audioRefs.current[id];
    if (selectedAudio) {
      if (selectedAudio.paused) {
        selectedAudio.play()
          .then(() => {
            setCurrentAudio(id);
          })
          .catch(error => {
            console.error("Error playing audio:", error);
          });
      } else {
        selectedAudio.pause();
        selectedAudio.currentTime = 0;
        setCurrentAudio(null);
      }
    }
  };

  const handleAudioEnd = (id) => {
    setCurrentAudio(null);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64 bg-[var(--black)]">
        <div className="w-8 h-8 border-4 border-[color:var(--yellow)/0.3] border-t-[var(--yellow)] rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6 bg-[var(--black)]">
      {/* Header with Dropdown Filter */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        <div>
          <h1 className="text-3xl font-extrabold text-[var(--yellow)]">Voice File Approval</h1>
          <p className="text-[color:var(--yellow)]">Review and approve user voice file submissions</p>
        </div>

        {/* Dropdown Filter */}
        <div className="relative mt-4 md:mt-0 w-48">
          <select
            value={selectedFilter}
            onChange={(e) => {
              setSelectedFilter(e.target.value);
              setPage(1);
              fetchUsersByStatus(e.target.value, 1);
            }}
            className="w-full appearance-none border-2 border-gray-300 bg-[var(--black)] text-[var(--yellow)] font-medium rounded-xl px-4 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-[color:var(--yellow)/0.6] shadow-sm cursor-pointer transition"
          >
            <option className="bg-[var(--black)] text-[var(--yellow)]" value="pending">⏳ Pending</option>
            <option className="bg-[var(--black)] text-[var(--yellow)]" value="approved">✅ Approved</option>
            <option className="bg-[var(--black)] text-[var(--yellow)]" value="rejected">❌ Rejected</option>
            <option className="bg-[var(--black)] text-[var(--yellow)]" value="all">📁 All</option>
          </select>

          {/* Small dropdown arrow icon */}
          <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
            <svg
              className="w-4 h-4 text-[var(--yellow)]"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
        {[
          { title: "Total Female Users", value: stats.totalUsers, icon: <FaUserFriends />, color: "yellow" },
          { title: "With Voice Upload", value: stats.totalFiles, icon: <FaFolderOpen />, color: "green" },
          { title: "Pending Review", value: stats.pendingReview, icon: <FaHourglassHalf />, color: "orange" },
          { title: "Approved", value: stats.approved, icon: <FaCheckCircle />, color: "blue" },
          { title: "Rejected", value: stats.rejected, icon: <FaMusic />, color: "purple" },
        ].map((stat, index) => {
          const colorClasses = {
            yellow: {
              bg: "bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-[var(--yellow)]/20",
              text: "text-[var(--yellow)]",
              icon: "text-[var(--yellow)]"
            },
            green: {
              bg: "bg-gradient-to-br from-green-500/10 to-green-500/5 border-green-500/20",
              text: "text-green-400",
              icon: "text-green-400"
            },
            orange: {
              bg: "bg-gradient-to-br from-orange-500/10 to-orange-500/5 border-orange-500/20",
              text: "text-orange-400",
              icon: "text-orange-400"
            },
            blue: {
              bg: "bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-blue-500/20",
              text: "text-blue-400",
              icon: "text-blue-400"
            },
            purple: {
              bg: "bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-purple-500/20",
              text: "text-purple-400",
              icon: "text-purple-400"
            }
          };

          const color = colorClasses[stat.color];

          return (
            <div
              key={index}
              className={`${color.bg} rounded-xl p-4 shadow-lg border-2`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className={`text-xs font-medium ${color.text} uppercase tracking-wider`}>
                    {stat.title}
                  </p>
                  <p className={`text-2xl font-bold ${color.text}`}>
                    {stat.value}
                  </p>
                </div>
                <div className={`text-3xl ${color.icon}`}>
                  {stat.icon}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Voice Files List */}
      <div className="bg-[var(--black)] border-2 border-gray-300 rounded-2xl p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <FaMusic className="text-[var(--yellow)] text-xl" />
            <h2 className="text-xl font-bold text-[var(--yellow)]">Voice Files ({pendingVerifications.length} users)</h2>
          </div>
          <div className="text-sm text-[color:var(--yellow)]">
            Showing {pendingVerifications.length} users
          </div>
        </div>
        <p className="text-[color:var(--yellow)] mb-4">Review, approve or reject user voice file submissions</p>

        {pendingVerifications.length > 0 ? (
          <div className="space-y-4">
            {pendingVerifications.map((user) => (
              <div key={user.id} className="flex flex-col sm:flex-row sm:items-center justify-between bg-[var(--black)] border-2 border-gray-300 rounded-xl p-4 shadow-sm hover:shadow-md transition-all">
                {/* Left: Profile Info */}
                <div className="flex items-center gap-3">
                  {/* <div className="bg-[var(--yellow)] text-[var(--black)] text-lg font-bold w-10 h-10 flex items-center justify-center rounded-full">
                    {user.fullName ? user.fullName.charAt(0).toUpperCase() : "U"}
                  </div> */}
                  <div className="w-10 h-10 rounded-full overflow-hidden border border-gray-200 bg-gray-100 flex items-center justify-center">
    {user.profileImage && user.profileImage !== "default-profile.jpg" ? (
        <img
            src={user.profileImage}
            alt={user.fullName}
            className="w-full h-full object-cover"
            onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/default-avatar.png"; // optional fallback
            }}
        />
    ) : (
        <FiUser className="text-gray-500 text-xl" />
    )}
</div>

                  <div>
                    <p className="font-semibold text-[var(--yellow)]">{user.fullName}</p>
                    <p className="text-sm text-[color:var(--yellow)]">{ user.phoneNumber ||user.email }</p>
                    <p className="text-sm text-[color:var(--yellow)]">
                      {user.gender || "female"} • {new Date(user.createdAt).toLocaleDateString()}
                    </p>
                    <p className="text-xs text-[var(--yellow)] mt-1">
                      Status:
                      <span className={`ml-1 px-2 py-1 rounded-full ${'bg-[var(--yellow)] text-[var(--black)]'
                        }`}>
                        {user.voiceVerificationStatus?.toUpperCase() || 'PENDING'}
                      </span>
                    </p>
                  </div>
                </div>

                {/* Right: Actions */}
                <div className="flex flex-wrap items-center gap-2 mt-3 sm:mt-0">
                  {user.voiceVerificationStatus === 'pending' && (
                    <>
                      {user.voice && (





                        <button
                          onClick={() => handlePlay(user.id)}
                          className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm transition ${currentAudio === user.id
                              ? "bg-[var(--yellow)] text-[var(--black)] border-2 border-gray-300"
                              : "bg-[var(--yellow)] text-[var(--black)] hover:opacity-90"
                            }`}
                        >
                          {currentAudio === user.id ? "⏸️ Pause" : "🎵 Play Voice"}
                        </button>
                      )}
                      <button
                        onClick={() => {
                          setSelectedUser(user);
                          setActionType("approve");
                        }}
                        className="flex items-center gap-1 px-3 py-1 bg-[var(--yellow)] text-[var(--black)] rounded-full text-sm hover:opacity-90"
                      >
                        ✅ Approve
                      </button>
                      <button
                        onClick={() => {
                          setSelectedUser(user);
                          setActionType("reject");
                        }}
                        className="flex items-center gap-1 px-3 py-1 bg-[var(--yellow)] text-[var(--black)] rounded-full text-sm hover:opacity-90"
                      >
                        ❌ Reject
                      </button>
                    </>
                  )}

                  {user.voiceVerificationStatus === 'approved' && (
                    <>
                    <button
      onClick={() => handleDeleteVoice(user.id)}
      className="flex items-center gap-1 px-3 py-1 bg-red-500 text-white rounded-full text-sm hover:opacity-90"
    >
      🗑️ Delete Voice
    </button>

                      {user.voice && (



                        <button
                          onClick={() => handlePlay(user.id)}
                          className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm transition ${currentAudio === user.id
                              ? "bg-[var(--yellow)] text-[var(--black)] border-2 border-gray-300"
                              : "bg-[var(--yellow)] text-[var(--black)] hover:opacity-90"
                            }`}
                        >
                          {currentAudio === user.id ? "⏸️ Pause" : "🎵 Play audio"}
                        </button>
                      )}
                      <span className="px-3 py-1 bg-[var(--yellow)] text-[var(--black)] rounded-full text-sm">
                        ✅ Approved
                      </span>
                    </>
                  )}

                  {user.voiceVerificationStatus === 'rejected' && (
                    <span className="px-3 py-1 bg-[var(--yellow)] text-[var(--black)] rounded-full text-sm">
                      ❌ Rejected
                    </span>
                  )}

                  {user.voice && (
                    <audio
                      ref={(el) => (audioRefs.current[user.id] = el)}
                      src={user.voice}
                      onEnded={() => handleAudioEnd(user.id)}
                      preload="metadata"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-[var(--yellow)] py-6 text-center">No voice verifications found</p>
        )}
      </div>

      {/* Voice Review Modal */}
      {selectedUser && (
        <VoiceReviewModal
          user={selectedUser}
          actionType={actionType}
          onClose={() => {
            setSelectedUser(null);
            setActionType(null);
            setReviewNotes("");
            setRejectionReason("");
          }}
          onSubmit={handleModalSubmit}
          reviewNotes={reviewNotes}
          setReviewNotes={setReviewNotes}
          rejectionReason={rejectionReason}
          setRejectionReason={setRejectionReason}
        />
      )}
      {/* Pagination */}
      {totalPages >= 1 && (
        <div className="flex items-center justify-center mt-8">
          <div className="flex items-center gap-2 bg-[var(--black)] border border-gray-300 px-4 py-3 rounded-xl shadow-lg">

            {/* Previous Button */}
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="px-3 py-2 rounded-lg text-sm font-semibold transition bg-[var(--yellow)] text-[var(--black)]
        disabled:opacity-40 disabled:cursor-not-allowed hover:opacity-80"
            >
              <FaChevronCircleLeft />
            </button>

            {/* Page Numbers */}
            <div className="flex items-center gap-2">
              {(() => {
                let pages = [];
                const createPageBtn = (p) => (
                  <button
                    key={p}
                    onClick={() => setPage(p)}
                    className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-semibold border transition 
                ${p === page
                        ? "bg-[var(--yellow)] text-[var(--black)] border-gray-300"
                        : "text-[var(--yellow)] border-gray-300 hover:bg-[var(--yellow)] hover:text-[var(--black)]"
                      }`}
                  >
                    {p}
                  </button>
                );

                const createDot = (key) => (
                  <span key={key} className="text-[var(--yellow)] font-bold px-2">…</span>
                );

                if (totalPages <= 7) {
                  for (let i = 1; i <= totalPages; i++) pages.push(createPageBtn(i));
                } else {
                  pages.push(createPageBtn(1));
                  pages.push(createPageBtn(2));

                  if (page > 4) pages.push(createDot("start"));

                  let start = Math.max(3, page - 1);
                  let end = Math.min(totalPages - 2, page + 1);

                  for (let i = start; i <= end; i++) pages.push(createPageBtn(i));

                  if (page < totalPages - 3) pages.push(createDot("end"));

                  pages.push(createPageBtn(totalPages - 1));
                  pages.push(createPageBtn(totalPages));
                }

                return pages;
              })()}
            </div>

            {/* Next Button */}
            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              className="px-3 py-2 rounded-lg text-sm font-semibold transition bg-[var(--yellow)] text-[var(--black)]
        disabled:opacity-40 disabled:cursor-not-allowed hover:opacity-80"
            >
              <FaCircleChevronRight />
            </button>

            <div className="flex items-center gap-2">
    <span className="text-[var(--yellow)] text-sm">
      Rows
    </span>

    <select
      value={limit}
      onChange={(e) => {
        setLimit(Number(e.target.value));
        setPage(1);
      }}
      className="border-2 border-gray-300 bg-[var(--black)] text-[var(--yellow)] rounded-xl px-3 py-2"
    >
      <option value={10}>10</option>
      <option value={25}>25</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
    </select>
  </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default VoiceApproval;

